var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mod-ask-bid"},[_c('OneTenChart',{attrs:{"stock":_vm.stock,"prices":_vm.prices,"context":_vm.context,"show-data":_vm.showAskBidData,"bid-display-vol-percent":_vm.bidDisplayVolPercent,"ask-display-vol-percent":_vm.askDisplayVolPercent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }